import React from 'react';
import styles from './index.module.less';
import martrimonyLogo from '@/common/assets/images/LogoHeaer.png';

const privacyPolicy = () => {
  // const [form] = Form.useForm();
  return (
    <div
      className={styles.maincontainer}
      // style={{
      //   paddingTop: '0px',
      //   paddingLeft: '00px',
      //   paddingRight: '0px',
      //   paddingBottom: '0px'
      // }}
    >
      <div className={styles.headerload}>
        <img
          src={martrimonyLogo}
          alt="matrimony logo"
          className={styles.logostyles}
        />
      </div>
      <div
        className={styles.cookieRow}
        // style={{
        //   display: 'flex',
        //   flexDirection: 'row',
        //   gap: '16px',
        //   marginTop: '8px',
        //   marginRight: '8px'
        // }}
      >
        <div className={styles.cookie}>
          <div className={styles.bgleft}></div>
        </div>
        <div className={styles.cookiecontainer}>
          <div className={styles.cookie_right}>
            <div className={styles.listview}>
              <h4>Privacy Policy</h4>
              <h6>Introduction</h6>
              <p>
                Welcome to Elite Samskurti (&quot;we&quot;, &quot;our&quot;,
                &quot;us&quot;, or &quot;the Service&quot;). We are committed to
                protecting your privacy and maintaining the confidentiality of
                your personal information. This Privacy Policy explains how we
                collect, use, disclose, and safeguard your information when you
                use our matrimony services application, website, and related
                services (collectively, the &quot;Service&quot;) in India.
              </p>

              <p>
                Please read this Privacy Policy carefully. By accessing or using
                the Service, you acknowledge that you have read, understood, and
                agree to be bound by this Privacy Policy. If you do not agree
                with our policies and practices, please do not use our Service.
              </p>

              <h6>Compliance with Indian Law</h6>

              <p>
                This Privacy Policy is designed to comply with Indian laws and
                regulations, including but not limited to the Information
                Technology Act, 2000, the Information Technology (Reasonable
                Security Practices and Procedures and Sensitive Personal Data or
                Information) Rules, 2011, and the pending Personal Data
                Protection Bill.
              </p>

              <h6>Information We Collect</h6>

              <h6>Personal Information</h6>

              <p>
                We collect information that you voluntarily provide to us when
                you:
              </p>

              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>Register for an account</p>
                  </li>
                  <li>
                    <p>Create or modify your profile</p>
                  </li>
                  <li>
                    <p>Set your preferences</p>
                  </li>
                  <li>
                    <p>Participate in features we offer</p>
                  </li>
                  <li>
                    <p>Contact customer support</p>
                  </li>
                  <li>
                    <p>Respond to surveys or communications</p>
                  </li>
                </ul>
                <p>This information may include:</p>
                <ul>
                  <li>
                    <p>
                      Basic details (name, age, gender, location, date of birth)
                    </p>
                  </li>
                  <li>
                    <p>
                      Contact information (email address, phone number,
                      residential address)
                    </p>
                  </li>
                  <li>
                    <p>
                      Profile information (photos, biography, education,
                      occupation, income)
                    </p>
                  </li>
                  <li>
                    <p>
                      Family details (family type, parents&apos; information,
                      siblings)
                    </p>
                  </li>
                  <li>
                    <p>
                      Cultural information (religion, caste, mother tongue,
                      community)
                    </p>
                  </li>
                  <li>
                    <p>
                      Matrimonial preferences (partner expectations, lifestyle
                      choices, beliefs)
                    </p>
                  </li>
                  <li>
                    <p>
                      Identity verification documents (Aadhaar, PAN, or other
                      government-issued IDs)
                    </p>
                  </li>
                  <li>
                    <p>Payment information</p>
                  </li>
                </ul>
              </div>

              <h6>Sensitive Personal Information</h6>
              <p>
                Under Indian law, certain information is classified as
                &quot;sensitive personal data or information&quot; (SPDI), which
                includes:
              </p>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>Passwords</p>
                  </li>
                  <li>
                    <p>
                      Financial information (bank account details, credit/debit
                      card information)
                    </p>
                  </li>
                  <li>
                    <p>Physical, physiological and mental health condition</p>
                  </li>
                  <li>
                    <p>Sexual orientation</p>
                  </li>
                  <li>
                    <p>Contact customer support</p>
                  </li>
                  <li>
                    <p>Biometric information</p>
                  </li>
                </ul>
                <p>
                  We collect and process such information with additional
                  safeguards and only when necessary for our Service.
                </p>
              </div>

              <h6>Automatically Collected Information</h6>
              <p>
                When you access or use our Service, we automatically collect:
              </p>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>
                      Device information (hardware model, operating system
                      version, unique device identifiers)
                    </p>
                  </li>
                  <li>
                    <p>
                      Log information (IP address, browser type, pages viewed,
                      time spent, links clicked)
                    </p>
                  </li>
                  <li>
                    <p>Location information (with your consent)</p>
                  </li>
                  <li>
                    <p>
                      Usage data (features used, interactions, search queries)
                    </p>
                  </li>
                  <li>
                    <p>Cookies and similar technologies</p>
                  </li>
                </ul>
                <p>
                  We collect and process such information with additional
                  safeguards and only when necessary for our Service.
                </p>
              </div>

              <h6>Information from Third Parties</h6>
              <p>We may receive information about you from:</p>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>
                      Social media platforms (if you choose to link accounts)
                    </p>
                  </li>
                  <li>
                    <p>Identity verification services</p>
                  </li>
                  <li>
                    <p>Payment processors</p>
                  </li>
                  <li>
                    <p>Other users (such as referrals or feedback)</p>
                  </li>
                </ul>
              </div>

              <h6>How We Use Your Information</h6>
              <p>We use the information we collect to:</p>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>Create and maintain your account</p>
                  </li>
                  <li>
                    <p>Provide our core matchmaking services</p>
                  </li>
                  <li>
                    <p>Personalize your experience</p>
                  </li>
                  <li>
                    <p>Process transactions</p>
                  </li>
                  <li>
                    <p>Communicate with you about our Service</p>
                  </li>
                  <li>
                    <p>Send promotional materials (with your consent)</p>
                  </li>
                  <li>
                    <p>Respond to your inquiries and support requests</p>
                  </li>
                  <li>
                    <p>Improve and develop our Service</p>
                  </li>
                  <li>
                    <p>Ensure security and prevent fraud</p>
                  </li>
                  <li>
                    <p>Comply with legal obligations</p>
                  </li>
                </ul>
              </div>

              <h6>Consent</h6>
              <p>
                By providing your personal information and using our Service,
                you consent to the collection and use of your information as
                described in this Privacy Policy. You can withdraw your consent
                at any time by closing your account or contacting us, though
                this may affect your ability to use certain features of our
                Service.
              </p>

              <h6>How We Share Your Information</h6>
              <p>We may share your information with:</p>
              <h6>Other Users</h6>

              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>
                      Profile information will be visible to other users
                      according to your privacy settings
                    </p>
                  </li>
                  <li>
                    <p>Communications you initiate with other users</p>
                  </li>
                </ul>
              </div>
              <h6>Service Providers</h6>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>
                      Companies that perform services on our behalf (hosting,
                      payment processing, analytics, customer support)
                    </p>
                  </li>
                  <li>
                    <p>
                      These providers have access to your information only to
                      perform these tasks
                    </p>
                  </li>
                </ul>
              </div>
              <h6>Business Transfers</h6>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>
                      If we are involved in a merger, acquisition, or sale of
                      assets
                    </p>
                  </li>
                </ul>
              </div>

              <h6>Legal Requirements</h6>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>When required by law or government authorities</p>
                  </li>
                  <li>
                    <p>To protect our rights, privacy, safety, or property</p>
                  </li>
                  <li>
                    <p>To protect against legal liability</p>
                  </li>
                </ul>
              </div>

              <h6>Data Storage and Processing in India</h6>
              <p>
                Your personal information is primarily stored and processed on
                servers located within India. However, in some cases, we may
                transfer your data to other countries for processing. In such
                cases, we ensure that the transfer complies with applicable
                Indian laws and that appropriate safeguards are in place.
              </p>

              <h6>Your Rights</h6>
              <p>In accordance with Indian law, you have the right to:</p>
              <ul>
                <li>
                  <p>
                    <b>Access:</b> Request access to personal information we
                    hold about you
                  </p>
                </li>
                <li>
                  <p>
                    <b>Correction:</b> Request correction of inaccurate or
                    incomplete information
                  </p>
                </li>
                <li>
                  <p>
                    <b>Deletion:</b> Request deletion of your personal
                    information
                  </p>
                </li>
                <li>
                  <p>
                    <b>Grievance Redressal:</b> Lodge complaints regarding the
                    processing of your personal information
                  </p>
                </li>
              </ul>
              <p>
                To exercise these rights, please contact our Grievance Officer,
                whose contact details are provided at the end of this Privacy
                Policy.
              </p>
              <h6>Account Settings and Profile Visibility</h6>
              <p>
                You can control the visibility of your profile and personal
                information through your account settings. We provide options
                to:
              </p>
              <ul>
                <li>
                  <p>Make your profile visible only to selected user groups</p>
                </li>
                <li>
                  <p>Hide specific personal details</p>
                </li>
                <li>
                  <p>Control who can contact you</p>
                </li>
                <li>
                  <p>Manage notification preferences</p>
                </li>
              </ul>
              <h6>Data Retention</h6>
              <p>
                We retain your personal information for as long as your account
                is active or as needed to provide you with our Service. We will
                retain and use your information as necessary to:
              </p>
              <ul>
                <li>
                  <p>Comply with our legal obligations</p>
                </li>
                <li>
                  <p>Resolve disputes</p>
                </li>
                <li>
                  <p>Enforce our agreements</p>
                </li>
                <li>
                  <p>Protect our legal interests</p>
                </li>
              </ul>
              <p>
                After your account is deleted, we may retain certain information
                in anonymized or aggregated form.
              </p>

              <h6>Data Security</h6>
              <p>
                We implement appropriate technical and organizational measures
                in accordance with the Information Technology (Reasonable
                Security Practices and Procedures and Sensitive Personal Data or
                Information) Rules, 2011, to protect your personal information
                from unauthorized access, disclosure, alteration, or
                destruction. However, no method of transmission over the
                Internet or electronic storage is 100% secure. While we strive
                to use commercially acceptable means to protect your personal
                information, we cannot guarantee its absolute security.
              </p>

              <h6>Children&aposs Privacy</h6>
              <p>
                Our Service is not intended for individuals under the age of 18.
                We do not knowingly collect personal information from children.
                If we learn that we have collected personal information from a
                child, we will take steps to delete that information as quickly
                as possible. If you believe we have any information from a child
                under 18, please contact us.
              </p>

              <h6>Cookies and Similar Technologies</h6>
              <p>
                We use cookies and similar technologies to collect information
                about your browsing activities and to analyze how you use our
                Service. You can control cookies through your browser settings
                and other tools. However, if you block certain cookies, you may
                not be able to use some features of our Service.
              </p>

              <h6>Third-Party Links and Services</h6>
              <p>
                Our Service may contain links to third-party websites, services,
                or applications that are not operated by us. We have no control
                over and assume no responsibility for the content, privacy
                policies, or practices of any third-party services. We encourage
                you to review the privacy policies of these third parties.
              </p>

              <h6>Changes to This Privacy Policy</h6>
              <p>
                We may update this Privacy Policy from time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                this page and updating the &quot;Last Updated&quot; date. You
                are advised to review this Privacy Policy periodically for any
                changes. Your continued use of the Service after we post changes
                to the Privacy Policy means you accept those changes.
              </p>

              <h6>Grievance Officer</h6>
              <p>
                In accordance with the Information Technology Act, 2000 and the
                Rules made thereunder, the contact details of the Grievance
                Officer are provided below:
              </p>
              <ul>
                {/* <li>
                  <p>
                    <strong>Name:</strong> Lakshminarayana Muppalla
                  </p>
                </li> */}
                <li>
                  <p>
                    <b>Email:</b>
                    <a
                      href="mailto:info@samskrutimatrimony.com"
                      style={{ marginLeft: '4px' }}
                    >
                      info@samskrutimatrimony.com
                    </a>
                  </p>
                </li>
                {/* <li>
                  <p>
                    <strong>Address:</strong> Hyderabad
                  </p>
                </li> */}
                {/* <strong>Address:</strong> Villa: 217, S T B L, Lakshmi
                    Manohara Gardens, Duvvada, Visakhapatnam, Visakhapatnam-
                    530046, Andhra Pradesh */}
              </ul>
              <p>
                You may contact the Grievance Officer for any questions,
                complaints, or concerns regarding the use of your personal
                information.
              </p>

              <h6>Contact Us</h6>
              <p>
                If you have any questions or concerns about this Privacy Policy
                or our data practices, please contact us at:
              </p>
              <ul>
                <li>
                  <p>
                    <b>Email:</b>
                    <a
                      href="mailto:info@samskrutimatrimony.com"
                      style={{ marginLeft: '4px' }}
                    >
                      info@samskrutimatrimony.com
                    </a>
                  </p>
                </li>
                {/* <li>
                  <p>
                    <b>Postal Address:</b> Hyderabad
                  </p>
                </li> */}
                {/* <b>Address:</b> Villa: 217, S T B L, Lakshmi Manohara
                      Gardens, Duvvada, Visakhapatnam, Visakhapatnam - 530046,
                      Andhra Pradesh */}
                {/* <li>
                  <p>
                    <b>Phone:</b> +91 XXXXXXXXXX
                  </p>
                </li> */}
              </ul>

              <p>
                <strong>Last Updated:</strong> 10th March 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default privacyPolicy;
